import { productIdFormat } from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import { WeightSchema } from "@redotech/redo-model/outbound-labels/util";
import * as z from "zod/v4";

const ImageSchema = z.object({
  id: z.string(),
  url: z.string(),
  alt_text: z.string(),
  position: z.number(),
});

export const updateProduct = {
  name: "updateProduct" as const,
  input: z.object({
    productId: productIdFormat.schema,
    title: z.string().optional(),
    description: z.string().optional(),
    vendor: z.string().nullable().optional(),
    tags: z.array(z.string()).optional(),
    sku: z.string().nullable().optional(),
    upc: z.string().nullable().optional(),
    barcodes: z.array(z.string()).optional(),
    price: z.number().nullable().optional(),
    cost: z.number().nullable().optional(),
    currency: z.string().nullable().optional(),
    weight: WeightSchema.nullable().optional(),
    taxCode: z.string().nullable().optional(),
    taxable: z.boolean().nullable().optional(),
    physicalItem: z.boolean().nullable().optional(),
    originCountry: z.string().nullable().optional(),
    hsCode: z.string().nullable().optional(),
    attributes: z.array(AttributeSchema).optional(),
    images: z.array(ImageSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
